export interface UserInfo {
  // The following fields will be available for all users
  user_info_id: number,
  age_year: number,
  age_years: number,
  gender: number,
  location_name: string,
  location_latitude: number,
  location_longitude: number,
  height: number,
  uniqueid: string,
  pref_allow_unmatched_messages: boolean,
  publicage?: boolean,

  // The following fields will only be available for the logged-in user
  email: string | undefined,
  accepted_terms: boolean | undefined,
  accepted_cookies: boolean | undefined,
  accepted_essential_cookies: boolean | undefined,
  set_password: boolean | undefined,
  set_preferences: boolean | undefined,
  has_email: boolean | undefined,
  desired_age_min: number | undefined,
  desired_age_max: number | undefined,
  desired_height_min: number | undefined,
  desired_height_max: number | undefined,
  desired_genders: number | undefined,
  desired_max_distance_miles: number | undefined,
  desire_men: boolean | undefined,
  desire_women: boolean | undefined,
  pref_notify_daily_email: boolean | undefined,
  pref_notify_weekly_email: boolean | undefined,
  pref_marketing_messages: boolean | undefined,
  pref_match_messages: boolean | undefined,
  pref_collab_messages: boolean | undefined,
  pref_welcome_messages: boolean | undefined,
  pref_chat_messages: boolean | undefined,
  subscriptions_uniqueid: string | undefined,
}

export const UNKNOWN_USER_INFO : UserInfo = {
  user_info_id: -1,
  age_year: -1,
  age_years: -1,
  gender: -1,
  location_name: "Unknown",
  location_latitude: -1,
  location_longitude: -1,
  height: -1,
  uniqueid: "unknown",
  pref_allow_unmatched_messages: false,

  email: undefined,
  accepted_terms: undefined,
  accepted_cookies: undefined,
  accepted_essential_cookies: undefined,
  set_password: undefined,
  set_preferences: undefined,
  has_email: undefined,
  desired_age_min: undefined,
  desired_age_max: undefined,
  desired_height_min: undefined,
  desired_height_max: undefined,
  desired_max_distance_miles: undefined,
  desired_genders: undefined,
  desire_men: undefined,
  desire_women: undefined,
  pref_notify_daily_email: undefined,
  pref_notify_weekly_email: undefined,
  pref_marketing_messages: undefined,
  pref_match_messages: undefined,
  pref_collab_messages: undefined,
  pref_welcome_messages: undefined,
  pref_chat_messages: undefined,
  subscriptions_uniqueid: undefined,
};

export enum Gender {
  GENDER_UNKNOWN = 0,
  GENDER_MAN = 1,
  GENDER_WOMAN = 2,
};

export const ALL_GENDERS_BITFLAGS = Gender.GENDER_MAN | Gender.GENDER_WOMAN;

export function getGenderName(gender: Gender, plural: boolean = false) : string {
  if (gender == Gender.GENDER_MAN) {
    return plural ? "Men" : "Man";
  } else if (gender == Gender.GENDER_WOMAN) {
    return plural ? "Women" : "Woman";
  } else if (gender == Gender.GENDER_UNKNOWN) {
    return "Unknown";
  } else {
    return "TODO: Not implemented: " + gender;
  }
}

export function includesGenderMan(bitflags: number): boolean {
  return (bitflags & Gender.GENDER_MAN) != 0;
}

export function includesGenderWoman(bitflags: number): boolean {
  return (bitflags & Gender.GENDER_WOMAN) != 0;
}

export function getDesiredGenderNames(desired_genders: number) : string {
  let result = "";
  for (const [key, value] of Object.entries(Gender)) {
    if (!isNaN(Number(key))) {
      // This condition filters out the numeric keys (reverse mappings like "1", "2", etc.)
      continue; 
    }
    const numericValue = Number(value);
    if (numericValue > 0) {
      if ((desired_genders & numericValue) != 0) {
        if (result.length > 0) {
          result += ", ";
        }
        const gender = Gender[key as keyof typeof Gender];
        result += getGenderName(gender, true);
      }
    }
  };
  return result;
}
